import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { mobileSettingsService } from "@/services/mobileSettingsService";
import {
  MobileScreenSettingsScreenTypes,
  UpdateMobileScreenSettings,
} from "@/types/mobile-settings";

export const mobileSettingsKeys = {
  all: ["mobile-settings"] as const,
  details: () => [...mobileSettingsKeys.all, "detail"] as const,
  detail: (hotelId: string, screenType: MobileScreenSettingsScreenTypes) =>
    [...mobileSettingsKeys.details(), hotelId, screenType] as const,
};

export const useMobileSettings = (
  hotelId: string,
  screenType: MobileScreenSettingsScreenTypes,
) => {
  const queryClient = useQueryClient();

  const {
    data: settings,
    isLoading,
    error,
  } = useQuery({
    queryKey: mobileSettingsKeys.detail(hotelId, screenType),
    queryFn: () => mobileSettingsService.getSettings(hotelId, screenType),
    enabled: !!hotelId,
    staleTime: 5 * 60 * 1000,
  });

  const updateMutation = useMutation({
    mutationFn: (data: UpdateMobileScreenSettings) =>
      mobileSettingsService.updateSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: mobileSettingsKeys.all,
      });
    },
  });

  return {
    settings,
    isLoading,
    error,
    updateSettings: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
  };
};
